module.exports = __webpack_public_path__ + "img/sl.19b9efa4.svg";